export enum CashAccountCustomFieldKey {
	AccountType = 'cashAccountAccountType',
	Name = 'cashAccountName',
}